export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $auth } = useNuxtApp();

  if ($auth.isLoggedIn()) return true
  else return $auth.redirectTo()
})